<template>
  <div class="table-placeholder-container w-full flex mb-8">
    <div
      v-if="!isSyncing && !dataLength"
      class="w-full flex justify-center">
      <div class="sm:w-full lg:w-1/2 flex flex-col items-center justify-center">
        <img
          src="../../../assets/images/data_not_found.png"
          class="h-auto"
        >
        <h3 class="font-bold mt-2 text-grey-dark">Data Not Found</h3>
      </div>
    </div>
    <div
      v-if="isSyncing"
      class="w-full flex flex-col">
      <div
        v-for="(i, index) in [1, 2, 3]"
        :key="index"
        class="w-full h-24 border-b border-grey">
        <div class="loader-container h-full pt-10 pl-4">
          <span />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PtLoader } from '@pathao/ui-components/esm/Loader';
export default {
  components: { PtLoader },
  props: {
    isSyncing: {
      type: Boolean,
      default: false,
    },
    dataLength: {
      type: Number,
      default: 0,
    },
    loaderClass: {
      type: String,
      default: 'text-white',
    },
  },
};
</script>
